import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";

var ChatIframe = function ChatIframe(props) {
  // console.log("Chat Iframe props", props);
  var room = props.room,
      type = props.type,
      channelName = props.channelName,
      mode = props.mode,
      updateDirectMessages = props.updateDirectMessages,
      chatServer = props.chatServer,
      auth_token = props.auth_token,
      domain = props.domain;
  var useStyles = makeStyles(function (theme) {
    return {
      iframeContainer: {
        paddingTop: "5px",
        height: "90vh"
      },
      iframe: {
        width: "100%",
        height: "100%"
      },
      chatIcon: {
        marginRight: "10px"
      },
      nameContainer: {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px"
      }
    };
  });
  var classes = useStyles();

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      iframe = _useState2[0],
      setIframe = _useState2[1];

  useEffect(function () {
    if (!process.env.ENVIRONMENT || process.env.ENVIRONMENT === "development") {// dev code
      // console.log(" process.env.ENVIRONMENT", process.env.ENVIRONMENT);
    } else {
      document.domain = domain;
    }
  }, []);

  var handleOnLoad = function handleOnLoad(e) {
    // console.log("iframe loaded");
    // console.log("e", e);
    // console.log("auth", auth_token);
    setIframe(document.getElementById("rocket-iframe").contentWindow);
    document.getElementById("rocket-iframe").contentWindow.postMessage({
      externalCommand: "login-with-token",
      token: auth_token
    }, chatServer);

    if (mode === "new") {
      // mode === "new" &&
      updateDirectMessages();
    }
  };

  useEffect(function () {
    iframe && iframe.postMessage({
      externalCommand: "go",
      //path: `direct/${room}`,
      path: "".concat(type, "/").concat(room)
    }, chatServer); // if (mode === "new") {
    //   // mode === "new" &&
    //   console.log("ChatIframe updateDirectMessages mode new");
    //   updateDirectMessages();
    // }
  }, [room, type, mode]);
  return room && /*#__PURE__*/React.createElement("div", {
    className: classes.iframeContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.nameContainer,
    variant: "h5"
  }, type === "direct" ? /*#__PURE__*/React.createElement(ChatIcon, {
    className: classes.chatIcon
  }) : "#", channelName), /*#__PURE__*/React.createElement("iframe", {
    className: classes.iframe,
    onLoad: handleOnLoad,
    src: "".concat(chatServer, "/").concat(type, "/").concat(room, "?layout=embedded") // width="80%"
    ,
    id: "rocket-iframe",
    sandbox: "allow-same-origin allow-scripts allow-popups allow-forms"
  }));
};

export { ChatIframe };